import * as exam from './exam';
import * as user from './user';
import * as join from './join';
import * as main from './main';
import * as board from './board';
import * as inbox from './inbox';
import * as learn from './learn';
import * as modal from './modal';
import * as login from './login';
import * as degree from './degree';
import * as appBar from './app-bar';
import * as comment from './comment';
import * as manager from './manager';
import * as standard from './standard';
import * as dormancy from './dormancy';
import * as prevPath from './prev-path';
import * as checklist from './checklist';
import * as portfolio from './portfolio';
import * as navigation from './navigation';
import * as findPwStore from './find-pw-store';
import * as findIdStore from './find-id-store';
import * as instantLearning from './instant-learning';
import * as currentComponent from './current-component';
import * as userInterfaceSetting from './user-interface-setting';

const store = {
  exam,
  manager,
  user,
  modal,
  learn,
  join,
  appBar,
  dormancy,
  login,
  findPwStore,
  findIdStore,
  checklist,
  degree,
  portfolio,
  comment,
  main,
  instantLearning,
  userInterfaceSetting,
  navigation,
  board,
  inbox,
  currentComponent,
  prevPath,
  standard,
};

export default store;
